export const FILE_STATUS = {
    10: "待准备",
    15: "待执行",
    20: "执行中",
    25: "执行成功",
    30: "执行失败"
}
